import { useState } from "react";
import "./Home.css";
export default function WorksSection() {
  const [activeIndex, setActiveIndex] = useState(0);

const worksData = [
  {
    number: 1,
    title: "Schedule An Appointment",
    desc: "Begin your journey to better health by booking an appointment with JEEVANDAAN Hospital. Schedule easily through phone or online and choose a time that fits your convenience.",
    img: "assets/img/all-images/works/work-img10.webp",
    color: "#E8F5FF", // light blue
  },
  {
    number: 2,
    title: "Consultation",
    desc: "Meet our experienced doctors for a detailed consultation, accurate diagnosis, and clear understanding of your health condition.",
    img: "assets/img/all-images/works/work-img10.webp",
    color: "#DFF7E1", // light green
  },
  {
    number: 3,
    title: "Personalized Treatment",
    desc: "We design a customized treatment plan based on your medical needs, using advanced technology and evidence-based care.",
    img: "assets/img/all-images/works/work-img10.webp",
    color: "#FAE8FF", // light pink/purple
  },
  {
    number: 4,
    title: "Ongoing Care",
    desc: "Our care doesn’t stop at treatment. We provide continuous monitoring, follow-ups, and guidance to ensure long-term recovery and wellness.",
    img: "assets/img/all-images/works/work-img10.webp",
    color: "#FFE8E8", // light red/pink
  },
];


  return (
    <div className="works4-section-area sp6">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 m-auto">
            <div className="heading4 text-center space-margin60">
              <h5 className="vl-section-subtitle">
            JEEVANDAAN Hospital <span> | </span> How It Works 
              </h5>
              <h2 className="vl-section-title">
                How JEEVANDAAN Hospital Cares for You

              </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="cs_case_study_1_list">

              {worksData.map((item, index) => (
                <div
                  key={index}
                  className={`cs_case_study cs_style_1 cs_hover_active ${
                    activeIndex === index ? "active" : ""
                  }`}
                   style={{ backgroundColor: item.color }} // dynamic color
                  onClick={() => setActiveIndex(index)}
                >
                  {/* Small pill */}
                  <div className="content-area1">
                    <div className="arrow">
                      <a>{item.number}</a>
                    </div>
                    <div className="text">
                      <a>{item.title}</a>
                    </div>
                  </div>

                  {/* Big open card */}
                  <div className="content-area">
                    <div className="arrow2">
                      <a>{item.number}</a>
                    </div>
                    <div className="space32"></div>
                    <a className="head">{item.title}</a>
                    <div className="space16"></div>
                    <p>{item.desc}</p>
                    <div className="space30"></div>
                    <div className="img1">
                      <img src={item.img} alt="" />
                    </div>
                  </div>

                </div>
              ))}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
